var map = {
	"./CEFoodCycle_Interreg.png": 2063,
	"./LCA-stepper-interface.png": 742,
	"./LogInMask.png": 7951,
	"./chatbot.png": 3973,
	"./company-data-form.png": 9261,
	"./food-surplus-form.png": 9328,
	"./found-solutions.png": 4419,
	"./goals-benefits-overview.png": 1483,
	"./lca-analysis-dashboard.png": 7826,
	"./lca-report.png": 6821,
	"./lca-stepper.png": 9880,
	"./registration-process.png": 965,
	"./select-provider-company.png": 3128,
	"./solution-details.png": 7678,
	"./solution-details_.png": 9851,
	"./solution-finder-interface.png": 3560,
	"./stepper-interface.png": 1717,
	"./what-is-foodcycle.png": 4854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2676;